// @spec GHG-STR-037
'use client';

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/ghg/reports/custom/')({
  beforeLoad: () => {
    // TanStack Router requires throwing the redirect result
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/ghg/reports', replace: true });
  },
});
